import styled, { css } from 'styled-components'
import DimComponent from './dim'
import DraggableComponent from './draggable'
import MoverComponent from './mover'
import ScalerComponent from './scaler'
import CropScaler from './types/scaler'

const pinned = css`
    left: 0;
    position: absolute;
    top: 0;
`

export const Container = styled.div`
    position: relative;
    user-select: none;
`

export const Dim = styled(DimComponent)`
    ${pinned}
    height: 100%;
    width: 100%;
`

export const Dimensions = styled.div`
    background: rgba(0, 0, 0, 0.4);
    border-radius: 4px;
    color: #fff;
    display: inline-block;
    font-size: 13px;
    font-weight: bold;
    left: 50%;
    opacity: 0;
    padding: 4px 8px;
    pointer-events: none;
    position: absolute;
    text-align: center;
    top: 50%;
    transform: translate(-50%, -50%);
    transition: opacity 0.15s ease-out;
`

export const Mover = styled(MoverComponent)`
    ${pinned}
`

export const Scaler = styled(ScalerComponent)<{ type: CropScaler }>`
    ${({ type }) => CropScaler.css(type, -2)}
    opacity: 0;
    position: absolute;
    transition: opacity 0.15s ease-out;
`

export const Draggable = styled(DraggableComponent)`
    ${pinned}

    &:hover ${Scaler},
    &:hover ${Dimensions},
    &[data-dragging="true"] ${Scaler},
    &[data-dragging="true"] ${Dimensions} {
        opacity: 1;
    }
`
